import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { RequestService } from 'src/app/services/request.service';
import { FormGroup } from '@angular/forms';
import { RegionData, RegionTable } from 'src/app/models/region.model';
import { takeUntil } from 'rxjs/operators';
import { Season } from 'src/app/models/Season.model';
import { TransportMode } from 'src/app/models/transportMode.model';
import { ServiceClass } from 'src/app/models/serviceClass.model';
import { LuggageType } from 'src/app/models/luggageType.model';
import { AgeGender } from 'src/app/models/AgeGender.model';
import { ComfortType } from 'src/app/models/comfort.mode';
import { StorageSpaceSingle } from 'src/app/models/StorageSpaces.model';
import { RegionUpdated } from 'src/app/models/RegionUpdated.model';
import { StorageAcceptance } from 'src/app/models/StorageAcceptance.model';
import { FileImport } from 'src/app/helper/FileImport';
import { LuggageCategory } from 'src/app/models/LuggageCategory.model';
import { TimeType } from 'src/app/models/TimeType.model';
import { StepsAmount } from 'src/app/models/StepsAmount.model';
import { Standback } from 'src/app/models/Standback.model';
import { DoorWidthReal } from 'src/app/models/DoorWidthReal.model';
import { AverageAisleWidth } from 'src/app/models/AverageAisleWidth.model';
import { FactorDistributionOfAlternativeRooms } from 'src/app/models/FactorDistributionOfAlternativeRooms.model.';
import { AccessibilityOfTheSeatsFactor } from 'src/app/models/AccessibilityOfTheSeatsFactor.model';
import { NotStorableBaggageFactor } from 'src/app/models/NotStorableBaggageFactor.model';
import { SimplicityLuggageAccommodationFactor } from 'src/app/models/SimplicityLuggageAccommodationFactor.model';
import { BaggageAccumulationFactor } from 'src/app/models/BaggageAccumulationFactor.model';
import { SeatsPerRunningMeterFactor } from 'src/app/models/SeatsPerRunningMeterFactor.model';
import { StepsWidth } from 'src/app/models/StepsWidth.model';
import { Place } from 'src/app/models/Place.model';
import { DoorWidthCalculated } from 'src/app/models/DoorWidthCalculated.model.';
import { ModalDialog } from 'src/app/Modal/modal';
import { WaitForModalResult } from 'src/app/helper/modalHelper';
import { MatDialog } from '@angular/material/dialog';
import { RackSecurity } from 'src/app/models/RackSecurity.model';
import { Subject } from 'rxjs';
import { LuggagePerFoldingSeat } from 'src/app/models/LuggagePerFoldingSeat.model';
import { MasterData } from 'src/app/models/masterData.model';
import { PersonValueFormat } from 'src/app/models/PersonValueFormat.model';

@Component({
  selector: 'app-datamanagement-details',
  templateUrl: './datamanagement-details.component.html',
  styleUrls: ['./datamanagement-details.component.scss']
})
export class DatamanagementDetailsComponent implements OnInit {
  datamanagement = {
    titelEdit: 'Edit Region', titelView: 'View Region',
    tab1Titel: 'Region', tab2Titel: 'AgeGenderDistribution', tab3Titel: 'AgeGenderLuggageFaktor', tab4Titel: 'LuggageSize', tab5Titel: 'TravelMix',
    tab6Titel: 'StorageAcceptance', tab7Titel: 'StorageFactor', tab8Titel: 'AgeGenderAdaptation', tab9Titel: 'PassengerChangeTimeVector', tab10Titel: 'DoorWidthReduction', tab10komma5Titel: 'DoorWidthAndPhysicalSeparationFactor', tab11Titel: 'BaseValueTime',
    tab12Titel: 'BaseFactor', tab13Titel: 'PolynomialFactor', tab14Titel: 'AisleWidth', tab15Titel: 'AlternativeRooms', tab16Titel: 'AccessibilityOfTheSeatsFactor',
    tab17Titel: 'AmountOfNotStorableBaggage', tab18Titel: 'SimplicityLuggageAccommodation', tab19Titel: 'LuggageRacksWhenBoarding', tab20Titel: 'BaggageAccumulation',
    tab21Titel: 'ReservationObligation', tab22Titel: 'CompartmentsAvailable', tab23Titel: 'SeatsPerRunningMeterFactor',
    tab24Titel: 'AgeDistribution', tab25Titel: 'AgeGenderAdaptationSteps', tab26Titel: 'PassengerChangeTimeVectorSteps',
    tab27Titel: 'StepsWidthFactor', tab28Titel: 'BoardingPlaceDensityOfPeopleFactor', tab29Titel: 'LocationWaysFactor', tab30Titel: 'SpecialFactors', buttonBack: "Back", buttonSave: "Save"
  }

  rackSecurities: RackSecurity[] = null;
  regionData: RegionData;
  regionForm: FormGroup<any> = new FormGroup({});
  currentRegionId: number;
  valueFormats: PersonValueFormat[] = null;
  seasons: Season[] = null;
  transportModes: TransportMode[] = null;
  serviceClasses: ServiceClass[] = null;
  luggageTypes: LuggageType[] = null;
  ageGender: AgeGender[] = null;
  comfortTypes: ComfortType[] = null;
  storageSpaces: StorageSpaceSingle[] = null;
  isEditable: boolean = null;
  isImported: boolean = false;
  isDeleteTravelMixes: boolean = false;
  validationCheck: boolean = false;
  travelMixValidationCheck: boolean = false;
  ageGenderDistributionValidationCheck: boolean = false;
  luggeCategory: LuggageCategory[] = null;
  timeType: TimeType[] = null;
  stepsAmount: StepsAmount[] = null;
  standback: Standback[] = null;
  doorWidthReal: DoorWidthReal[] = null;
  averageAisleWidth: AverageAisleWidth[] = null;
  factorDistributionOfAlternativeRooms: FactorDistributionOfAlternativeRooms[] = null;
  accessibilityOfTheSeatsFactor: AccessibilityOfTheSeatsFactor[] = null;
  notStorableBaggageFactor: NotStorableBaggageFactor[] = null;
  simplicityLuggageAccommodationFactor: SimplicityLuggageAccommodationFactor[] = null;
  baggageAccumulationFactor: BaggageAccumulationFactor[] = null;
  seatsPerRunningMeterFactor: SeatsPerRunningMeterFactor[] = null;
  stepsWidth: StepsWidth[] = null;
  places: Place[] = null;
  doorWidthCalculated: DoorWidthCalculated[] = null;
  backButtonModalMessage: string = "Please verify that you have saved the region, otherwise the unsaved changes will be lost!";
  private unscubscribe$ = new Subject<void>();


  @ViewChild('ageGenderDistributionChild', { static: false }) ageGenderDistributionChild;
  @ViewChild('ageGenderLuggageFactorChild', { static: false }) ageGenderLuggageFaktorChild;
  @ViewChild('luggageSizeChild', { static: false }) luggageSizeChild;
  @ViewChild('storageAcceptanceChild', { static: false }) storageAcceptanceChild;
  @ViewChild('ageGenderStorageFactorChild', { static: false }) ageGenderStorageFactorChild;
  @ViewChild('ageGenderAdaptation', { static: false }) ageGenderAdaptation;
  @ViewChild('passengerChangeTimeVector', { static: false }) passengerChangeTimeVector;
  @ViewChild('doorWidthReduction', { static: false }) doorWidthReduction;
  @ViewChild('doorWidthAndPhysicalSeparationFactor', { static: false }) doorWidthAndPhysicalSeparationFactor;
  @ViewChild('baseValueTime', { static: false }) baseValueTime;
  @ViewChild('baseFactor', { static: false }) baseFactor;
  @ViewChild('polynomialFactor', { static: false }) polynomialFactor;
  @ViewChild('aisleWidth', { static: false }) aisleWidth;
  @ViewChild('alternativeRooms', { static: false }) alternativeRooms;
  @ViewChild('accessibilityOfTheSeats', { static: false }) accessibilityOfTheSeats;
  @ViewChild('amountOfNotStorableBaggage', { static: false }) amountOfNotStorableBaggage;
  @ViewChild('simplicityLuggageAccommodation', { static: false }) simplicityLuggageAccommodation;
  @ViewChild('luggageRacksWhenBoarding', { static: false }) luggageRacksWhenBoarding;
  @ViewChild('baggageAccumulation', { static: false }) baggageAccumulation;
  @ViewChild('reservationObligation', { static: false }) reservationObligation;
  @ViewChild('compartmentsAvailable', { static: false }) compartmentsAvailable;
  @ViewChild('seatsPerRunningMeter', { static: false }) seatsPerRunningMeter;
  @ViewChild('ageDistribution', { static: false }) ageDistribution;
  @ViewChild('ageGenderAdaptationSteps', { static: false }) ageGenderAdaptationSteps;
  @ViewChild('passengerChangeTimeVectorSteps', { static: false }) passengerChangeTimeVectorSteps;
  @ViewChild('stepsWidthFactor', { static: false }) stepsWidthFactor;
  @ViewChild('boardingPlaceDensityOfPeopleFactor', { static: false }) boardingPlaceDensityOfPeopleFactor;
  @ViewChild('locationWaysFactor', { static: false }) locationWaysFactor;
  @ViewChild('specialFactorsChild', { static: false }) specialFactors;
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private dialog: MatDialog,
    private requestService: RequestService,
  ) {
  }

  ngOnInit() {
    this.route.params
      .pipe(takeUntil(this.unscubscribe$))
      .subscribe(params => {
        this.currentRegionId = parseInt(params['regionId'].toString());
        this.isEditable = parseInt(params['isEditor'].toString()) == 0 ? true : false;

        this.requestService.getMasterData()
          .pipe(takeUntil(this.unscubscribe$))
          .subscribe(masterData => {
            this.requestService.getRegionData(this.currentRegionId)
              .pipe(takeUntil(this.unscubscribe$))
              .subscribe(region => {

                this.mapSources(masterData);
                let fileImportContent = sessionStorage.getItem('fileImport');
                let deleteTravelMixes = sessionStorage.getItem('fileImportDeleteTravelMixes') == "true";
                this.markAsDeletedFromOldRegion(fileImportContent, deleteTravelMixes, region);

                if (fileImportContent !== "" && fileImportContent !== null) {
                  this.isImported = true;
                  let fileImport: FileImport = new FileImport(this.regionData, this.seasons, this.transportModes, fileImportContent);
                  this.regionData = fileImport.regionDataOutput;
                }
              });
          });
      });
  }

  mapSources(data: MasterData) {
    this.transportModes = data.transportModeList;
    this.seasons = data.seasonList;
    this.valueFormats = data.personValueFormatList;
    this.luggageTypes = data.luggageTypeList;
    this.serviceClasses = data.serviceClassList;
    this.ageGender = data.ageGenderList;
    this.comfortTypes = data.comfortTypeList;
    this.storageSpaces = data.storageSpaceSingleList;
    this.timeType = data.timeTypeList;
    this.luggeCategory = data.luggageCategoryList;
    this.stepsAmount = data.stepsAmountList;
    this.standback = data.standbackList;
    this.doorWidthReal = data.doorWidthRealList;
    this.averageAisleWidth = data.averageAisleWidthList;
    this.factorDistributionOfAlternativeRooms = data.factorDistributionOfAlternativeRoomsList;
    this.accessibilityOfTheSeatsFactor = data.accessibilityOfTheSeatsFactorList;
    this.notStorableBaggageFactor = data.notStorableBaggageFactorList;
    this.simplicityLuggageAccommodationFactor = data.simplicityLuggageAccommodationFactorList;
    this.baggageAccumulationFactor = data.baggageAccumulationFactorList;
    this.seatsPerRunningMeterFactor = data.seatsPerRunningMeterFactorList;
    this.stepsWidth = data.stepsWidthList;
    this.places = data.placeList;
    this.doorWidthCalculated = data.doorWidthCalculatedList;
    this.rackSecurities = data.rackSecurityList;
  }

  navigateBack() {
    this.router.navigate(['datamanagement/list/']);
  }

  onSubmit() {
    this.ageGenderDistributionChild.save();
    this.ageGenderLuggageFaktorChild.save();
    this.luggageSizeChild.save();
    this.storageAcceptanceChild.save();
    this.ageGenderStorageFactorChild.save();
    this.ageGenderAdaptation.save();
    this.passengerChangeTimeVector.save();
    this.doorWidthReduction.save();
    this.doorWidthAndPhysicalSeparationFactor.save();
    this.baseValueTime.save();
    this.baseFactor.save();
    this.polynomialFactor.save();
    this.aisleWidth.save();
    this.alternativeRooms.save();
    this.accessibilityOfTheSeats.save();
    this.amountOfNotStorableBaggage.save();
    this.simplicityLuggageAccommodation.save();
    this.luggageRacksWhenBoarding.save();
    this.baggageAccumulation.save();
    this.reservationObligation.save();
    this.compartmentsAvailable.save();
    this.seatsPerRunningMeter.save();
    this.ageDistribution.save();
    this.ageGenderAdaptationSteps.save();
    this.passengerChangeTimeVectorSteps.save();
    this.stepsWidthFactor.save();
    this.boardingPlaceDensityOfPeopleFactor.save();
    this.locationWaysFactor.save();
    this.specialFactors.save();
    let dataToSend: RegionUpdated = this.mapBackToRegionData();

    this.requestService.writeRegionData(dataToSend)
      .pipe(takeUntil(this.unscubscribe$))
      .subscribe(resp => {
        // reload region data!!!
      });

  }
  mapBackToRegionData(): RegionUpdated {
    let updatedData: RegionUpdated = new RegionUpdated();
    let region: RegionTable = new RegionTable();
    region.name = this.regionForm.get('name').value;
    region.id = this.currentRegionId;
    region.createdAtUtc = this.regionForm.get('createdAtUtc').value;
    region.ageGenderDistributionId = this.regionForm.get('ageGenderDistribution').value.id;
    region.ageGenderLuggageFactorId = this.regionForm.get('ageGenderLuggageFactor').value.id;
    region.ageGenderStorageFactorId = null;
    region.oppositeDoorReductionFactorValue = this.regionForm.get('oppositeDoorReductionFactorValue').value as number;
    region.beforeSeatReductionFactorValue = this.regionForm.get('beforeSeatReductionFactorValue').value as number;
    region.notUsableSeatFactorValue = this.regionForm.get('notUsableSeatFactor').value as number;
    region.distanceBetweenPeople = this.regionForm.get('distanceBetweenPeople').value as number;
    region.distanceBetweenPeopleAisle = this.regionForm.get('distanceBetweenPeopleAisle').value as number;
    region.distanceBetweenPeopleStairs = this.regionForm.get('distanceBetweenPeopleStairs').value as number;
    region.rackCapacityRoundingThreshold = this.regionForm.get('rackCapacityRoundingThreshold').value as number;
    region.minimumUnderSeatHeight = this.regionForm.get('minimumUnderSeatHeight').value as number;
    region.overheadHeightReductionFactor = this.regionForm.get('overheadHeightReductionFactor').value as number;
    region.overheadLengthReductionFactor = this.regionForm.get('overheadLengthReductionFactor').value as number;
    region.overheadLengthReductionThreshold = this.regionForm.get('overheadLengthReductionThreshold').value as number;
    region.handleReductionFactor = this.regionForm.get('handleReductionFactor').value as number;
    region.overencumberFactor = this.regionForm.get('overencumberFactor').value as number;
    updatedData.region = region;
    updatedData.ageGenderDistribution = this.regionForm.get('ageGenderDistribution').value;
    updatedData.ageGenderLuggageFactor = this.regionForm.get('ageGenderLuggageFactor').value;
    updatedData.ageGenderStorageFactor = this.regionForm.get('ageGenderStorageFactor').value;
    updatedData.defaults = this.regionForm.get('defaults').value;
    updatedData.luggageSize = this.regionForm.get('luggageSize').value;
    let storageAcceptance: StorageAcceptance = new StorageAcceptance();
    storageAcceptance.id = this.currentRegionId;
    storageAcceptance.storageAcceptancePerComfortTypeList = this.regionForm.get('storageAcceptance').value;
    updatedData.storageAcceptance = storageAcceptance;
    updatedData.travelMixes = this.regionForm.get('travelMixes').value;
    updatedData.ageGenderAdaptation = this.regionForm.get('ageGenderAdaptation').value;
    updatedData.passengerChangeTimeVector = this.regionForm.get('passengerChangeTimeVector').value;
    updatedData.doorWidthReduction = this.regionForm.get('doorWidthReduction').value;
    updatedData.doorWidthAndPhysicalSeparationFactor = this.regionForm.get('doorWidthAndPhysicalSeparationFactor').value;
    updatedData.baseValueTime = this.regionForm.get('baseValueTime').value;
    updatedData.baseFactor = this.regionForm.get('baseFactor').value;
    updatedData.polynomialFactor = this.regionForm.get('polynomialFactor').value;
    updatedData.aisleWidth = this.regionForm.get('aisleWidth').value;
    updatedData.alternativeRooms = this.regionForm.get('alternativeRooms').value;
    updatedData.accessibilityOfTheSeats = this.regionForm.get('accessibilityOfTheSeats').value;
    updatedData.amountOfNotStorableBaggage = this.regionForm.get('amountOfNotStorableBaggage').value;
    updatedData.simplicityLuggageAccommodation = this.regionForm.get('simplicityLuggageAccommodation').value;
    updatedData.luggageRacksWhenBoarding = this.regionForm.get('luggageRacksWhenBoarding').value;
    updatedData.baggageAccumulation = this.regionForm.get('baggageAccumulation').value;
    updatedData.reservationObligation = this.regionForm.get('reservationObligation').value;
    updatedData.compartmentsAvailable = this.regionForm.get('compartmentsAvailable').value;
    updatedData.seatsPerRunningMeter = this.regionForm.get('seatsPerRunningMeter').value;
    updatedData.ageDistribution = this.regionForm.get('ageDistribution').value;
    updatedData.ageGenderAdaptationSteps = this.regionForm.get('ageGenderAdaptationSteps').value;
    updatedData.passengerChangeTimeVectorSteps = this.regionForm.get('passengerChangeTimeVectorSteps').value;
    updatedData.stepsWidthFactor = this.regionForm.get('stepsWidthFactor').value;
    updatedData.boardingPlaceDensityOfPeopleFactor = this.regionForm.get('boardingPlaceDensityOfPeopleFactor').value;
    updatedData.oppositeDoorReductionFactorValue = this.regionForm.get('oppositeDoorReductionFactorValue').value as number;
    updatedData.beforeSeatReductionFactorValue = this.regionForm.get('beforeSeatReductionFactorValue').value as number;
    updatedData.securityAdjustmentFactor = this.regionForm.get('securityAdjustmentFactor').value;

    updatedData.distanceBetweenPeople = this.regionForm.get('distanceBetweenPeople').value as number;
    updatedData.distanceBetweenPeopleAisle = this.regionForm.get('distanceBetweenPeopleAisle').value as number;
    updatedData.distanceBetweenPeopleStairs = this.regionForm.get('distanceBetweenPeopleStairs').value as number;
    updatedData.rackCapacityRoundingThreshold = this.regionForm.get('rackCapacityRoundingThreshold').value as number;
    updatedData.minimumUnderSeatHeight = this.regionForm.get('minimumUnderSeatHeight').value as number;
    updatedData.overheadHeightReductionFactor = this.regionForm.get('overheadHeightReductionFactor').value as number;
    updatedData.overheadLengthReductionFactor = this.regionForm.get('overheadLengthReductionFactor').value as number;
    updatedData.overheadLengthReductionThreshold = this.regionForm.get('overheadLengthReductionThreshold').value as number;
    updatedData.handleReductionFactor = this.regionForm.get('handleReductionFactor').value as number;
    updatedData.luggagePerFoldingSeat = this.regionForm.get('luggagePerFoldingSeat').value as LuggagePerFoldingSeat;
    return updatedData;
  }

  markAsDeletedFromOldRegion(fileImportContent: string, deleteTravelMixes: boolean, region: RegionData) {
    let tmpRegionData = region;
    if (fileImportContent !== "" && fileImportContent !== null && deleteTravelMixes) {
      tmpRegionData.travelMixes.forEach(f => f.isMarkedAsDelete = true);
    }
    this.regionData = tmpRegionData;
  }

  checkValidation() {
    if (this.ageGenderDistributionValidationCheck && this.travelMixValidationCheck) {
      this.validationCheck = true;
    }
    else {
      this.validationCheck = false;
    }
  }

  updateValiadationAgeGenderDistribution(validation: boolean) {
    this.ageGenderDistributionValidationCheck = validation;
    this.checkValidation();
  }
  updateValidationTravelMix(validation: boolean) {
    this.travelMixValidationCheck = validation;
    this.checkValidation();
  }
  canDeactivate() {
    const dialogRef = this.dialog.open(ModalDialog, {
      data: {
        title: 'Warning',
        message: this.backButtonModalMessage,
        showCancel: true,
        cancelButtonText: 'Cancel',
        saveButtonText: 'Leave'
      }
    });
    return WaitForModalResult(dialogRef);
  }

  ngOnDestroy() {
    this.unscubscribe$.next();
    this.unscubscribe$.complete();
  }
}
